import styled from 'styled-components';

export const ContentBoxContainer = styled.div`
    width: 100%;
    height: auto;
    padding: 3em;
    // margin: ${window.screen.width <= 1000 ? '10%' : '2%'}; 
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // align-self: center;
    // position: relative;

    .header-info {
        text-align: center;
        line-height: 2rem;
        width: 860px;
        max-width: 95%;
        display: flex;
        flex-direction: column;
        align-items: center;
        align-self: center;

        h2 {
           font-size: ${window.screen.width <= 1000 ? '20px' : '35px'}; 
           padding: 0.5em;
           margin: 0;
        }
        
        p {
           font-size: ${window.screen.width <= 1000 ? '15px' : '20px'}; 
        }

        .button{
            width: 300px;
            maxWidth: '80%',
        }
    }
`;